import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer-orders')({
  component: CustomerOrdersLayout,
});

function CustomerOrdersLayout() {
  return <Outlet />;
}
